module.exports = __webpack_public_path__ + "static/img/einvest-ekyc-cover.65189ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recent-works/einvest-ekyc-cover.png
// module id = yQVR
// module chunks = 1